import React from "react";
import { Typography, Grid, Paper, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
// import PrivateTeachingArtwork from "../components/PrivateTeachingArtwork";
// import PayPerSessionArtwork from "../components/PayPerSessionArtwork";
// import AnytimeAnywhereArtwork from "../components/AnytimeAnywhereArtwork";
import TeacherIcon from "../components/TeacherIcon";
import CoinIcon from "../components/CoinIcon";
import TimeAndDayIcon from "../components/TimeAndDayIcon";

const useStyles = makeStyles({
  title: {
    textAlign: "center",
    fontSize: 35,
    fontWeight: "medium",
    margin: "50px 0px",
    color: "#022233"
  },
  whyUsCard: {
    textAlign: "center",
    transition: "box-shadow 500ms ease, transform 500ms ease",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "0 0 50px 0 rgba(175, 175, 175, 0.2)"
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "4rem 2vw",

    borderRadius: 10
  },
  cardTitle: {
    fontSize: "18px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#3e3e53"
  },
  cardContent: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#3e3e53",
    marginTop: 16
  }
});

export default function WhyUs() {
  const classes = useStyles();
  return (
    <section>
      <Typography className={classes.title} variant="h5" component="h2">
        چرا لینگوتاک؟
      </Typography>
      <Grid container justify="center">
        <Grid item xs={11} md={10} lg={9} xlg={8}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Paper className={classes.whyUsCard} elevation={0}>
                <CardContent>
                  <TeacherIcon />
                  <Typography className={classes.cardTitle}>
                    آموزش رو در رو
                  </Typography>
                  <Typography className={classes.cardContent}>
                    کلاس‌های لینگوتاک به‌صورت مکالمه ویدیویی و خصوصی برگزار
                    می‌شود.
                  </Typography>
                </CardContent>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper className={classes.whyUsCard} elevation={0}>
                <CardContent>
                  <CoinIcon />
                  <Typography className={classes.cardTitle}>
                    پرداخت به ازای هر جلسه
                  </Typography>

                  <Typography className={classes.cardContent}>
                    در لینگوتاک شما به اِزای هر جلسه هزینه‌ی کلاس‌ها را پرداخت
                    می‌کنید.
                  </Typography>
                </CardContent>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper className={classes.whyUsCard} elevation={0}>
                <CardContent>
                  <TimeAndDayIcon />
                  <Typography className={classes.cardTitle}>
                    در همه ‌جا و همه ‌وقت!
                  </Typography>

                  <Typography className={classes.cardContent}>
                    کلاس آنلاین به شما امکان زمان‌بندی آزادتری می‌دهد. یعنی
                    می‌توانید کلاس خصوصی‌ خود را با بهترین قیمت در هر جا و هر
                    زمان برگزار کنید.
                  </Typography>
                </CardContent>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </section>
  );
}
